import { NavbarProps } from '@common/ui/navigation/navbar/navbar';
import { useNavigate } from '@common/ui/navigation/use-navigate';
import { Button } from '@ui/buttons/button';
import { ButtonColor } from '@ui/buttons/get-shared-button-style';
import { IconButton } from '@ui/buttons/icon-button';
import { Item, ListboxItemProps } from '@ui/forms/listbox/item';
import { Trans } from '@ui/i18n/trans';
import { PersonIcon } from '@ui/icons/material/Person';
import { Menu, MenuTrigger } from '@ui/menu/menu-trigger';
import { useSettings } from '@ui/settings/use-settings';
import { Fragment, ReactElement } from 'react';
import { Link } from 'react-router';
import { useIsIOS } from '@app/web-player/hooks/use-is-ios';

interface NavbarAuthButtonsProps {
  primaryButtonColor?: ButtonColor;
  navbarColor?: NavbarProps['color'];
  items?: ReactElement<ListboxItemProps>[];
}
export function NavbarAuthButtons({
  primaryButtonColor,
  navbarColor,
  items,
}: NavbarAuthButtonsProps) {
  if (!primaryButtonColor) {
    primaryButtonColor = navbarColor === 'primary' ? 'elevated' : 'primary';
  }

  return (
    <Fragment>
      <MobileButtons items={items} />
      <DesktopButtons primaryButtonColor={primaryButtonColor} />
    </Fragment>
  );
}

interface DesktopButtonsProps {
  primaryButtonColor: ButtonColor;
}
function DesktopButtons({ primaryButtonColor }: DesktopButtonsProps) {
  const { registration } = useSettings();
  const isIOS = useIsIOS();
  return (
    <div className="text-sm max-md:hidden">
      {!registration?.disable && !isIOS && (
        <Button
          elementType={Link}
          to="/register"
          variant="text"
          className="mr-10"
        >
          <Trans message="Register" />
        </Button>
      )}
      <Button
        elementType={Link}
        to="/login"
        variant="raised"
        color={primaryButtonColor}
      >
        <Trans message="Login" />
      </Button>
    </div>
  );
}

interface MobileButtonsProps {
  items?: ReactElement<ListboxItemProps>[];
}
function MobileButtons({ items }: MobileButtonsProps) {
  const { registration } = useSettings();
  const navigate = useNavigate();
  const isIOS = useIsIOS();
  return (
    <MenuTrigger>
      <IconButton size="md" className="md:hidden">
        <PersonIcon />
      </IconButton>
      <Menu>
        <Item value="login" onSelected={() => navigate('/login')}>
          <Trans message="Login" />
        </Item>
        {!registration?.disable && !isIOS && (
          <Item value="register" onSelected={() => navigate('/register')}>
            <Trans message="Register" />
          </Item>
        )}
        {items}
      </Menu>
    </MenuTrigger>
  );
}
